import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const getTaskDetail = async (payload: { taskId: string; type: string }) => {
  const { taskId, type } = payload
  const response = await axios.get(`${getAPIService}/v2/api/cron-tasks/detail/${type}/${taskId}`)
  return response.data
}
